import React, { useState } from 'react';
import { AlarmClock, X } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useEvent } from '../i18n/EventProvider';

export default function ClockChangeBanner() {
  const { t } = useI18n();
  const { event } = useEvent();
  const cc = event.clock_change;
  const key = cc ? `planted_clock_${cc.date}` : '';
  const [hidden, setHidden] = useState(() => { try { return !!key && sessionStorage.getItem(key) === '1'; } catch (_) { return false; } });
  const now = Date.now();
  const changeAt = cc ? Date.parse(`${cc.date}T12:00:00Z`) : 0;
  const inWindow = cc && now >= changeAt - 7 * 864e5 && now <= Date.parse(`${event.date_iso}T23:59:59Z`);
  if (!inWindow || hidden) return null;
  const copy = cc.direction === 'back' ? t.clock.back : t.clock.forward;
  const close = () => { try { sessionStorage.setItem(key, '1'); } catch (_) { /* private mode */ } setHidden(true); };
  return (
    <div data-testid="clock-change-banner" className="bg-[#1f3a2a] text-[#f5efe3] text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-9 flex items-center justify-center gap-2 relative">
        <AlarmClock size={15} className="text-[#d4a63d] shrink-0" />
        <span className="truncate"><strong className="font-medium text-[#d4a63d]">{copy.title}</strong><span className="hidden sm:inline"> · {copy.text}</span></span>
        <button type="button" onClick={close} aria-label="Dismiss" data-testid="clock-change-banner-close" className="absolute right-4 lg:right-8 p-1 rounded-full hover:bg-[#f5efe3]/10"><X size={14} /></button>
      </div>
    </div>
  );
}
